import { create } from 'zustand';

const useAuthStore = create(set => ({
  token: localStorage.getItem('accessToken') || null,
  setToken: token => {
    localStorage.setItem('accessToken', token);
    set({ token });
  },
  clearToken: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    set({ token: null });
  },
  logout: () => {
    localStorage.removeItem('accessToken'); // Token'ları sil
    localStorage.removeItem('refreshToken');
    set({ token: null }); // State'i sıfırla
    window.location.href = '/login'; // Login sayfasına yönlendir
  },
}));

export default useAuthStore;
